import { Button, Chip, Divider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { StarOutlineRounded } from '@material-ui/icons';
import ArrowBack from '@material-ui/icons/ArrowBack';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import { JobLayout } from '@orientaction/components';
import { IJobMatching } from '@orientaction/components/Form/CreateEditAdmin/Job/type';
import clsx from 'clsx';
import { ReactElement, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as IconSensDuTravail } from '../../../Asset/svg/matching1.svg';
import { ReactComponent as IconBesoin } from '../../../Asset/svg/matching2.svg';
import { ReactComponent as IconPersonality } from '../../../Asset/svg/matching3.svg';
import { ReactComponent as IconTalents } from '../../../Asset/svg/matching4.svg';
import { ReactComponent as IconEquilibre } from '../../../Asset/svg/matching5.svg';
import DetailJobInfo from './DetailJobInfo';
import DetailJobMatching from './DetailJobMatching';
import { useStyles } from './style';

const importante_de_la_vie: { [key: string]: number } = {
  'Très forte': 4,
  Forte: 3,
  Moyenne: 2,
  Faible: 1,
};

const DetailJobComponent = ({
  isPreview = false,
  job,
  backUrl = '/admin/emploi/annonces',
  candidates,
  children,
}: {
  isPreview: boolean;
  backUrl?: string;
  job: IJobMatching;
  candidates?: number;
  children?: ReactElement;
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [tools, setTools] = useState<{ [key: string]: string[] }>();
  const [languages, setLanguages] = useState<{ [key: string]: string }>();
  useEffect(() => {
    if (job && job.matching_talents) {
      if (job.matching_talents.hard_skills_applications) {
        const obj: { [key: string]: string[] } = {};

        (job.matching_talents.hard_skills_applications as Array<string>).forEach(i => {
          const texts = i.split(' - ');
          if (!obj[texts[0]]) obj[texts[0]] = [];
          obj[texts[0]].push(texts[1]);
        });
        setTools(obj);
      }
      if (job.matching_talents.hard_skills_languages) {
        const langs: { [key: string]: string } = {};
        Object.keys(job.matching_talents.hard_skills_languages)
          .filter(k => k.includes('Langue '))
          .map(k => k.split('Langue ')[1])
          .forEach(k => {
            if (job.matching_talents?.hard_skills_languages[`Langue ${k}`]) {
              langs[job.matching_talents?.hard_skills_languages[`Langue ${k}`]] =
                job.matching_talents?.hard_skills_languages[`Niveau de langue ${k}`];
            }
          });
        setLanguages(langs);
      }
    }
  }, [job]);

  return (
    <JobLayout isNew3={true}>
      <div className={classes.header}>
        <div>
          <Button onClick={() => history.push(backUrl)}>
            <Typography variant="h6" className={classes.breadcrumbs}>
              <ArrowBack fontSize="small" /> Revenir {isPreview ? "à l'éditeur" : 'aux annonces'}
            </Typography>
          </Button>
          <Grid
            container={true}
            spacing={2}
            direction="row"
            alignItems="center"
            className={classes.containerProfile}>
            <Grid item={true} xs={12}>
              <Typography className={classes.titleItalic}>
                Prévisualisation de votre annonce
              </Typography>
              <Typography variant="h2" className={classes.title}>
                {job.title}
              </Typography>{' '}
            </Grid>
            <Grid item={true} xs={6}>
              <div className={classes.flex}>
                <RoomOutlinedIcon fontSize="small" />
                <Typography variant="h6" className={classes.address}>
                  {job.addressCity} {job.addressZipcode}
                </Typography>{' '}
              </div>
            </Grid>
            {!!candidates && (
              <Grid item={true} xs={6}>
                <div className={clsx(classes.flex, classes.floatRight)}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      history.push(`/admin/emploi/annonce/${job.id}`);
                    }}
                    className={classes.candidatesBtn}>
                    Consulter les candidats
                  </Button>
                  <Chip label={candidates} variant="outlined" className={classes.candidatesChips} />
                </div>
              </Grid>
            )}
          </Grid>
        </div>
      </div>
      <div className={classes.body}>
        <div style={{ position: 'relative', top: '-60px' }}>
          <div className={classes.containerSection}>
            <DetailJobInfo job={job} languages={languages} />
          </div>
          <div className={classes.containerSection}>
            <DetailJobMatching
              color="#74B089"
              id="matching_sens_du_travail"
              job={job}
              Icon={IconSensDuTravail}
              title="Sens au travail"
              tableRowCount={6}
              keys={['sens', 'destins']}
            />
          </div>
          <div className={classes.containerSection}>
            <DetailJobMatching
              color="#B34B4B"
              id="matching_besoins_et_motivation"
              job={job}
              tableRowCount={6}
              Icon={IconBesoin}
              title="Besoins et motivation"
              keys={['principaux_needspro', 'salaire']}
            />
          </div>
          <div className={classes.containerSection}>
            <DetailJobMatching
              color="#FE5756"
              id="matching_personnalite"
              job={job}
              tableRowCount="auto"
              Icon={IconPersonality}
              title="Personalité"
              keys={['principaux_needspro']}
            />
          </div>
          <div className={classes.containerSection}>
            <DetailJobMatching
              color="#BC72A7"
              id="matching_talents"
              job={job}
              tableRowCount={12}
              Icon={IconTalents}
              title="Talents"
              subtitle="16 soft skills Harmony"
              keys={['soft_skills_harmony']}>
              <Grid container={true}>
                <Grid
                  item={true}
                  xs={12}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 20,
                    marginBottom: 16,
                  }}>
                  <Typography className={classes.titleTable}>Autoévaluation Hard skills</Typography>
                </Grid>
                <Grid container={true}>
                  <Grid item={true} xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography className={classes.titleSubTable}>Langues étrangères</Typography>
                  </Grid>
                  <Grid
                    item={true}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 10,
                      marginBottom: 20,
                    }}>
                    {languages &&
                      Object.keys(languages).map(k => (
                        <Chip
                          key={`${k}:  ${languages[k]}`}
                          className={classes.languageChip}
                          label={`${k}:  ${languages[k]}`}
                          color="secondary"
                        />
                      ))}
                  </Grid>
                </Grid>
                <Grid container={true}>
                  <Grid item={true} xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography className={classes.titleSubTable}>Outils informatiques</Typography>
                  </Grid>
                  <Grid item={true} xs={12}>
                    {tools &&
                      Object.keys(tools).map((k, i) => (
                        <div key={k}>
                          <div className={classes.section}>
                            <Grid container={true}>
                              <Grid item={true} xs={12}>
                                <Typography className={classes.toolsTitle}>{k}</Typography>
                                <Typography className={classes.toolsItem}>
                                  {tools[k].join(' ,')}
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                          {i + 1 < Object.keys(tools).length && (
                            <Divider
                              variant="middle"
                              style={{ borderTop: '1px dashed #A9AAB8', margin: 10, height: 0 }}
                            />
                          )}
                        </div>
                      ))}
                  </Grid>
                </Grid>
              </Grid>
            </DetailJobMatching>
          </div>
          <div className={classes.containerSection}>
            <DetailJobMatching
              color="#5B6FB6"
              id="matching_talents"
              job={job}
              tableRowCount={12}
              Icon={IconEquilibre}
              title="Équilibre de vie"
              keys={[]}>
              <Grid container={true} alignItems="center" className={classes.ratingBorder}>
                <div>
                  <Typography className={classes.ratingTitle}>Importance de la vie pro:</Typography>
                </div>
                <div className={classes.ratingStars}>
                  {Array.from(
                    Array(
                      importante_de_la_vie[
                        job.matching_equilibre_de_vie?.importance_vie_pro[
                          'Importance de la vie pro'
                        ]
                      ] ?? 0
                    )
                  ).map(i => (
                    <StarOutlineRounded key={i} color="primary" />
                  ))}
                  {Array.from(
                    Array(
                      4 -
                        (importante_de_la_vie[
                          job.matching_equilibre_de_vie?.importance_vie_pro[
                            'Importance de la vie pro'
                          ]
                        ] ?? 0)
                    )
                  ).map(i => (
                    <StarOutlineRounded key={i} color="disabled" />
                  ))}
                </div>
                <div>
                  <Typography className={classes.ratingValue}>
                    {job.matching_equilibre_de_vie?.importance_vie_pro['Importance de la vie pro']}
                  </Typography>
                </div>
              </Grid>
            </DetailJobMatching>
          </div>
        </div>
      </div>
      {!!children && children}
    </JobLayout>
  );
};

export default DetailJobComponent;
